import { Dialog } from "@material-ui/core";
import { Button, DialogActions, DialogTitle, Stack } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import useAreaOfInterest from "../../../../../hooks/useAreaOfInterest";

const DeleteAoi = ({
  selectedAoi,
  setSelectedAoi,
}: {
  selectedAoi: { name: string; id: string };
  setSelectedAoi: Dispatch<SetStateAction<{ id: string; name: string }>>;
}) => {
  const { deleteAreaOfInterest } = useAreaOfInterest();
  const handleDeleteFile = async () => {
    await deleteAreaOfInterest
      .mutateAsync({ id: selectedAoi.id })
      .then(() => setSelectedAoi({ id: "", name: "" }));
  };

  return (
    <Dialog open={!!selectedAoi.id} maxWidth="sm" fullWidth>
      <Stack p={3}>
        <DialogTitle>
          Are you sure you want to delete <b>{selectedAoi.name}</b> ?
        </DialogTitle>
        <DialogActions>
          <Stack direction="row" justifyContent="space-between" gap={1}>
            <Button
              variant="outlined"
              onClick={() => setSelectedAoi({ id: "", name: "" })}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              sx={{ bgcolor: "#d32f2f" }}
              onClick={handleDeleteFile}
            >
              Delete
            </Button>
          </Stack>
        </DialogActions>
      </Stack>
    </Dialog>
  );
};

export default DeleteAoi;
